import { render, staticRenderFns } from "./payError.vue?vue&type=template&id=7b341aca&scoped=true&"
import script from "./payError.vue?vue&type=script&lang=js&"
export * from "./payError.vue?vue&type=script&lang=js&"
import style0 from "./payError.vue?vue&type=style&index=0&id=7b341aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b341aca",
  null
  
)

export default component.exports